import moment from 'moment';
import ContactNote from 'types/ContactNote';
import { CN_MGMT_API_URL } from 'services/constants';
import removeEmptyProperties from 'utils/requestUtil';
import { assertNotNullOrUndefined } from 'utils/utils';
import { axiosInstance } from '../shared/axios/axiosConfig';

/**
 * Call the controller to create a new contact note
 */
const create = async (newNote: ContactNote) => {
  // Create a filtered copy of the contact note object
  const filteredNote = Object.fromEntries(
    Object.entries(newNote).filter(([_, value]) => value !== '' && value !== null),
  );

  const response = await axiosInstance.post(`${CN_MGMT_API_URL}/frontend/notes`, filteredNote);
  return response.data;
};

/**
 * Call the controller to modify an existing contact note
 */
// TODO: Remove ContactNote when the existing creation flow is removed
const updateContactNote = async (id: string, editedContactNote: ContactNote) => {
  removeEmptyProperties(editedContactNote);
  const request = axiosInstance.put(`${CN_MGMT_API_URL}/frontend/notes/${id}`, editedContactNote);
  const response = await request;
  return response.data;
};

/**
 * Call the controller to get all notes that has as creator the current user
 */
const getMyNotes = async (
  creator?: string | null,
  teamView?: boolean | null,
  query?: string | null,
  dateRange?: any[],
  globalPartnerId?: string | null,
  techId?: string | null,
  usedInBr?: boolean,
) => {
  assertNotNullOrUndefined(dateRange);

  // We need to send the query data via POST to comply with security standards
  const request = await axiosInstance.post(`${CN_MGMT_API_URL}/frontend/notes/search`, {
    query: query,
    start: dateRange[0] || null,
    //We add an extra day to include all dates on the end date.
    end: (dateRange[1] && moment(dateRange[1]).add(24, 'hours')) || null,
    globalPartnerId,
    ...(usedInBr ? { brId: techId } : { partnerId: techId }),
    creator,
    teamView,
  });
  const response = await request;
  return response.data;
};

const getEmployeeOptions = async () => {
  const response = await axiosInstance.get(`${CN_MGMT_API_URL}/internal/v1/employees`);
  // return mockEmployeeOptionsList;
  return response.data;
};

const contactNoteService = { create, updateContactNote, getMyNotes, getEmployeeOptions };
export default contactNoteService;
